import React from 'react'
import DocumentTitle from 'react-document-title'
import Button from '../components/Button'
//import Carousel from '../components/Carousel'
import { getPageTitle } from "../utility/utility"
import './ApartmentStory.scss'

import TaviVideoImg from "../images/story/tavi_video_placeholder.jpg"
//import TaviTestimonialImg from "../images/story/tavi_testimonial.jpg"
import GridImage1 from "../images/story/1.png";
import GridImage2 from "../images/story/2.png";
import GridImage3 from "../images/story/3.png";
import GridImage4 from "../images/story/4.png";
import GridImage5 from "../images/story/5.png";
import GridImage6 from "../images/story/6.png";
import GridImage7 from "../images/story/7.png";
import GridImage8 from "../images/story/8.png";
import GridImage9 from "../images/story/9.png";
import GridImage10 from "../images/story/10.png";

export default class DeveloperPage extends React.Component {
  static pageTitle(listings, routeParams) { // eslint-disable-line no-unused-vars
    return '300 Ashland | Apartment Stories with Tavi Gevinson';
  }

  render() {
    // Thes may become dynamic props later
    const heading = "Life in 300 Ashland";
    const videoUnitText = 'Media mogul and all around style icon Tavi Gevinson is a 300 Ashland resident and partner. Get an inside look at her apartment decor decision-making process.'
    /* const testimonialImagesAndText = [
      [TaviTestimonialImg, '“Its kind of a dream to work with that view. I get sunrises if I’m early enough, and it affects the day more than I would’ve imagined.”'],
      [TaviTestimonialImg, '“Its kind of a dream to work with that view. I get sunrises if I’m early enough, and it affects the day more than I would’ve imagined.”'],
      [TaviTestimonialImg, '“Its kind of a dream to work with that view. I get sunrises if I’m early enough, and it affects the day more than I would’ve imagined.”'],
      [TaviTestimonialImg, '“Its kind of a dream to work with that view. I get sunrises if I’m early enough, and it affects the day more than I would’ve imagined.”']
    ]; */

    const imageSourcesAndCaptions = [
      [GridImage1, "Lorem ipsum dolor sit amet..."],
      [GridImage2, "Lorem ipsum dolor sit amet..."],
      [GridImage3, "Lorem ipsum dolor sit amet..."],
      [GridImage4, "Lorem ipsum dolor sit amet..."],
      [GridImage5, "Lorem ipsum dolor sit amet..."],
      [GridImage6, "Lorem ipsum dolor sit amet..."],
      [GridImage7, "Lorem ipsum dolor sit amet..."],
      [GridImage8, "Lorem ipsum dolor sit amet..."],
      [GridImage9, "Lorem ipsum dolor sit amet..."],
      [GridImage10, "Lorem ipsum dolor sit amet..."]
    ];

    return (
      <DocumentTitle title={getPageTitle(this.constructor, this.props)}>
        <div className="apartment-story" id="main" role="main">
          <section className="apartment-story__header">
            <h1 className="apartment-story__header-text">{heading}</h1>
          </section>
          <section className="apartment-story__feature apartment-story__feature--video">
            <div className="apartment-story__feature-copy">
              <p>{videoUnitText}</p>
              <Button is='a' variants={['elongated', 'primary']} href='https://blog.twotreesny.com/tavi-300-ashland-apartment' target='_blank'>
                Explore Here
              </Button>
            </div>
            <div className="apartment-story__feature-media">
              <img alt="Tavi" src={TaviVideoImg} className="apartment-story__feature-media-item" />
            </div>
          </section>
          {/* <Carousel
               variants={['overlaid-arrows']}
               startSlide={0}
               slides={testimonialImagesAndText.map(([img, text]) => ({
                 custom: (
                   <section className="apartment-story__feature apartment-story__feature--static">
                     <div className="apartment-story__feature-media">
                       <img src={img} className="apartment-story__feature-media-item" />
                     </div>
                     <div className="apartment-story__feature-copy">
                       <p>{text}</p>
                     </div>
                   </section>
                 )
               }))} /> */}
          <section className="apartment-story__social">
            <h2 className="apartment-story__social-heading">Views from the building</h2>
            <div className="apartment-story__social-image-grid">
              {imageSourcesAndCaptions.map(([source, caption]) =>  // eslint-disable-line no-unused-vars
                <div className="apartment-story__social-image-grid-item">
                  <div className="apartment-story__social-image-grid-item-inner">
                    <img src={source} className="apartment-story__social-image-grid-item-media" />
                    {/* <span className="apartment-story__social-image-grid-item-caption">{caption}</span> */}
                  </div>
                </div>
              )}
            </div>
          </section>
        </div>
      </DocumentTitle>
    );
  }
}



// WEBPACK FOOTER //
// ./client/pages/ApartmentStory.js